var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"page",staticClass:"task-page",class:{ 'task-page--mobile': _vm.isMobile }},[_c('div',{staticClass:"task-page__card"},[_c('task-form',{key:_vm.$route.fullPath,attrs:{"ref-item":_vm.$route.params.refItem,"ref-type":_vm.$route.params.refType,"copy":_vm.$route.params.copy},on:{"close":_vm.leave}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }